<template>
  <div class="layout">
    <div id="countMainBox">
      <div id="countPageTitle">百科数据资源综合统计</div>

      <div id="mideleContentBox">
        <div id="countLeftBox" class="contentBox">
          <div class="countZyBox">
            <div id="countZy"></div>
            <span class="moreView" @click="ZyMoreView(1)">查看更多</span>
          </div>

          <!-- <div class="countZtBox">
            <div id="countZt"></div>
            <span class="moreView" @click="ZtMoreView(1)">查看更多</span>
          </div> -->

          <div class="countLeftBottom">
            <div id="resourceSuffix"></div>
          </div>
        </div>
        <div id="countMiddleBox" class="contentBox">
          <div style="margin-left: 20px">资源总量：</div>
          <div id="countSum">
            <span class="integer"></span>
            <span class="dot">.</span>
            <span class="fraction"></span>
            <span class="dot">万</span>
          </div>
          <div id="sumData">
            <div class="imgSumBox">图片：<span></span>条</div>
            <div class="videoSumBox">视频：<span></span>条</div>
            <div class="audioSumBox">音频：<span></span>条</div>
            <div class="sumBox">总计：<span></span></div>
          </div>

          <div id="countTypeBox">
            <div class="title">资源类型统计</div>
            <span class="moreView" @click="resourceTypeDialog = true"
              >查看更多</span
            >
            <el-table
              :data="countTypeTableShowData"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column
              ><el-table-column
                prop="subInfo.name"
                show-overflow-tooltip
                min-width="80"
                label="名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="count"
                show-overflow-tooltip
                min-width="80"
                width="130"
                label="数量"
                align="center"
              ></el-table-column
            ></el-table>
          </div>

          <div id="productBox">
            <div class="title">产品统计</div>
            <span class="moreView" @click="productMoreView(1)">查看更多</span>
            <el-table
              :data="productViewTableData"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column
              ><el-table-column
                prop="name"
                show-overflow-tooltip
                min-width="80"
                label="名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="count"
                show-overflow-tooltip
                min-width="80"
                width="130"
                label="数量"
                align="center"
              ></el-table-column
            ></el-table>
          </div>
        </div>
        <div id="countRightBox" class="contentBox">
          <div class="productResourceBox">
            <div id="productResource"></div>
            <span class="moreView" @click="PRMoreView(1)">查看更多</span>
          </div>
          <div class="words_chart">
            <div class="hotTitle">热搜词</div>
            <div id="tagbox">
              <a
                href="javascript:void(0)"
                onclick="location.href='/search?query='+encodeURI('教育')"
              >
                教育
              </a>
            </div>
          </div>
          <!-- <div class="productResourceBox">
            <div id="industryCount"></div>
            <span class="moreView" @click="industryCountDialog = true"
              >查看更多</span
            >
          </div> -->
          <!-- <div id="resourceType"></div> -->
        </div>
      </div>
      <div id="bottomBox">
        <div id="knowledgeGraph"></div>
      </div>
    </div>
    <!-- 专业学科分类统计 -->
    <el-dialog
      title="专业学科分类统计"
      :visible.sync="countZyDialog"
      width="600px"
    >
      <el-table
        :data="countZyTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="index"
          min-width="50"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="subInfo.name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangeZy"
          :current-page="currentPageZy"
          layout="total, prev, pager, next, jumper"
          :total="totalSizeZy"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 专题类型资源统计 -->
    <el-dialog
      title="专题类型资源统计"
      :visible.sync="countZtDialog"
      width="600px"
    >
      <el-table
        :data="countZtTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="index"
          min-width="50"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="subInfo.name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangeZt"
          :current-page="currentPageZt"
          layout="total, prev, pager, next, jumper"
          :total="totalSizeZt"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 产品多媒体资源统计 -->
    <el-dialog
      title="产品多媒体资源统计"
      :visible.sync="productResourceDialog"
      width="800px"
    >
      <el-table
        :data="productResourceTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="index"
          min-width="50"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="images"
          show-overflow-tooltip
          min-width="80"
          label="图片数量"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="audios"
          show-overflow-tooltip
          min-width="80"
          label="音频数量"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="videos"
          show-overflow-tooltip
          min-width="80"
          label="视频数量"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangePR"
          :current-page="currentPagePR"
          layout="total, prev, pager, next, jumper"
          :total="totalSizePR"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 产品资源统计 -->
    <el-dialog title="产品资源统计" :visible.sync="productDialog" width="800px">
      <el-table
        :data="productTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="index"
          min-width="50"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="up"
          show-overflow-tooltip
          min-width="80"
          label="已上架"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangeProduct"
          :current-page="currentPageProduct"
          layout="total, prev, pager, next, jumper"
          :total="totalSizeProduct"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 行业资源分类统计 -->
    <el-dialog
      title="行业资源分类统计"
      :visible.sync="industryCountDialog"
      width="800px"
    >
      <el-table
        :data="industryTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="index"
          min-width="50"
          align="center"
        ></el-table-column
        ><el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="value"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <!-- <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangeProduct"
          :current-page="currentPageProduct"
          layout="total, prev, pager, next, jumper"
          :total="totalSizeProduct"
        >
        </el-pagination>
      </div> -->
    </el-dialog>
    <!-- 资源类型统计 -->
    <el-dialog
      title="资源类型统计"
      :visible.sync="resourceTypeDialog"
      width="800px"
    >
      <el-table
        :data="countTypeTableData"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column
        ><el-table-column
          prop="subInfo.name"
          show-overflow-tooltip
          min-width="80"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          show-overflow-tooltip
          min-width="80"
          label="数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="up"
          show-overflow-tooltip
          min-width="80"
          label="已上架"
          align="center"
        ></el-table-column
      ></el-table>
      <!-- 列表分页 -->
      <!-- <div class="pagination-box">
        <el-pagination
          @current-change="handleCurrentChangeProduct"
          :current-page="currentPageProduct"
          layout="total, prev, pager, next, jumper"
          :total="totalSizeProduct"
        >
        </el-pagination>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
import * as echarts from "echarts";
export default {
  data: function () {
    return {
      countTypeTableData: [],
      countTypeTableShowData: [],
      productTableData: [],
      productViewTableData: [],
      productTableDataAll: [],
      countZyTableDataAll: [],
      countZyTableData: [],
      countZtTableDataAll: [],
      countZtTableData: [],
      industryTableData: [],
      productResourceTableDataAll: [],
      productResourceTableData: [],
      productPageNum: 1,
      productActive: "first",

      // 分页
      currentPageZy: 1,
      totalSizeZy: 50,
      currentPageZt: 1,
      totalSizeZt: 50,
      currentPagePR: 1,
      totalSizePR: 50,
      currentPageProduct: 1,
      totalSizeProduct: 50,

      //弹窗
      countZyDialog: false,
      countZtDialog: false,
      productResourceDialog: false,
      productDialog: false,
      industryCountDialog: false,
      resourceTypeDialog: false,

      //数据
      countInteger: 0,
      countFraction: 0,
    };
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    let that = this;
    var tagData = [
      "中国",
      "数字图书馆",
      "图书馆",
      "毛泽东",
      "麻油",
      "阿司匹林",
      "化学",
      "俄罗斯",
      "计算机",
      "李白",
      "丝绸之路",
      "中国历史",
      "科学",
      "历史",
      "力学",
      "心理学",
      "鲁迅",
      "孔子",
      "中国大百科全书",
      "数学",
      "胰岛素",
      "文化",
      "博物馆",
      "哲学",
      "周恩来",
      "五四运动",
      "苏联",
      "考古学",
    ];
    var tagHtml = "";
    for (var p = 0; p < tagData.length; p++) {
      tagHtml +=
        ' <a href="/fullSearch?query=' +
        tagData[p] +
        '" target="_blank">' +
        tagData[p] +
        "</a>";
    }
    $("#tagbox").html(tagHtml);

    function randomColor() {
      var cs = ["c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9"];
      var n = Math.floor(Math.random() * 9);
      return cs[n];
    }
    for (var i = 0; i < $("#tagbox a").length; i++) {
      $("#tagbox a").eq(i).addClass(randomColor());
    }
    this.onload3dtags();
    var resourceSuffixChart = echarts.init(
      document.querySelector("#resourceSuffix")
    );
    // var resourceTypeChart = echarts.init(
    //   document.querySelector("#resourceType")
    // );
    var countZyChart = echarts.init(document.querySelector("#countZy"));
    // var countZtChart = echarts.init(document.querySelector("#countZt"));
    var productResourceChart = echarts.init(
      document.querySelector("#productResource")
    );
    // var industryCountChart = echarts.init(
    //   document.querySelector("#industryCount")
    // );
    var knowledgeGraphChart = echarts.init(
      document.querySelector("#knowledgeGraph")
    );

    // 知识图谱
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/word/knowledgeGraph",
      // contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          console.log(response.obj);
          var knowledgeGraphoption = {
            title: {
              text: "知识图谱",
              subtext: "Default layout",
              top: "bottom",
              left: "right",
            },
            tooltip: {},
            series: [
              {
                name: "知识图谱",
                type: "graph",
                layout: "force",
                data: response.obj.nodes,
                links: response.obj.links,
                roam: true, //缩放和平移
                draggable: true, //节点可拖拽
                zoom: 2,
                center: ["46%", "50%"],
                label: {
                  show: true,
                  position: "bottom",
                },
                itemStyle: {
                  color: "#50b58d",
                },
                force: {
                  repulsion: 100,
                },
              },
            ],
          };
          knowledgeGraphChart.setOption(knowledgeGraphoption);
          knowledgeGraphChart.on("click", function (params) {
            console.log(params.data.name);
            window.open(
              "/knowledgeContent?wd=" + encodeURIComponent(params.data.name)
            );
          });
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
      error: function (data) {
        console.log(data);
      },
    });

    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/stat/count",
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          //获取数据总量处理显示
          var countIntegerPart = Math.floor(
            response.obj.countNum.countItem / 10000
          );
          var decimalPartString = String(
            response.obj.countNum.countItem / 10000 - countIntegerPart
          ).slice(2, 5);
          // var countIntegerPart = Math.floor(response.obj.countNum / 10000);
          // var decimalPartString = String(
          //   response.obj.countNum / 10000 - countIntegerPart
          // ).slice(2, 5);
          var countIntegerArray = String(countIntegerPart).split("");
          var decimalArray =
            decimalPartString.length > 0 ? decimalPartString.split("") : [];
          $.each(countIntegerArray, function (index, element) {
            $(".integer").append(
              "<span class='integerNum numberShow'>" + element + "</span>"
            );
          });
          $.each(decimalArray, function (index, element) {
            $(".fraction").append(
              "<span class='fractionNum numberShow'>" + element + "</span>"
            );
          });
          var sumData = response.obj.countNum.countResource;
          $("#sumData .imgSumBox span").text(sumData.图片);
          $("#sumData .videoSumBox span").text(sumData.视频);
          $("#sumData .audioSumBox span").text(sumData.音频);
          var countSpace = response.obj.countNum.countSpace;
          countSpace = (
            countSpace.substr(0, countSpace.length - 2) / 1024
          ).toString();
          countSpace = countSpace.substr(0, 7) + "GB";
          console.log(countSpace);
          $("#sumData .sumBox span").text(countSpace);

          //获取table数据
          that.countTypeTableData = response.obj.countType;
          for (var h = 0; h < 5; h++) {
            that.countTypeTableShowData.push(response.obj.countType[h]);
          }
          that.countZyTableDataAll = response.obj.countZy;
          // that.countZtTableDataAll = response.obj.countZt;
          that.productResourceTableDataAll = response.obj.productResource;

          //处理产品资源数据
          that.productTableDataAll = response.obj.product;
          for (let index = 0; index < 5; index++) {
            that.productViewTableData.push(response.obj.product[index]);
          }

          //处理行业数据
          // that.industryTableData = response.obj.countIndustry;
          // var industryShowData = [];
          // for (var m = 0; m < 10; m++) {
          //   industryShowData.push(response.obj.countIndustry[m]);
          // }
          // console.log(industryShowData);

          //处理图表数据
          var resourceSuffixData = [],
            countZyDataX = [],
            countZyDataY = [],
            // countZtDataX = [],
            // countZtDataY = [],
            productResourceDataX = [],
            productResourceDataImg = [],
            // productResourceData3D = [],
            productResourceDataAudio = [],
            productResourceDataVideo = [];
          for (var i = 0; i < response.obj.resourceSuffix.length; i++) {
            resourceSuffixData.push({
              value: response.obj.resourceSuffix[i].count,
              name: response.obj.resourceSuffix[i].formatType,
            });
          }
          for (var j = 0; j < 10; j++) {
            countZyDataX.push(response.obj.countZy[j].subInfo.name);
            countZyDataY.push(response.obj.countZy[j].count);
          }
          // for (var k = 0; k < 10; k++) {
          //   countZtDataX.push(response.obj.countZt[k].subInfo.name);
          //   countZtDataY.push(response.obj.countZt[k].count);
          // }
          var productResourceLength = 0;
          if (response.obj.productResource.length >= 10) {
            productResourceLength = 10;
          } else {
            productResourceLength = response.obj.productResource.length;
          }
          for (var l = 0; l < productResourceLength; l++) {
            productResourceDataX.push(response.obj.productResource[l].name);
            productResourceDataImg.push(response.obj.productResource[l].images);
            // productResourceData3D.push(response.obj.productResource[l].3ds);
            productResourceDataAudio.push(
              response.obj.productResource[l].audios
            );
            productResourceDataVideo.push(
              response.obj.productResource[l].videos
            );
          }

          // 多媒体文件类型比例option
          var resourceSuffixoption = {
            title: {
              text: "多媒体文件类型比例",
              left: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              orient: "vertical",
              left: "7%",
              top: "10%",
              data: response.obj.resourceSuffix.map((item) => {
                return item.formatType;
              }),
            },
            series: [
              {
                name: "多媒体文件类型比例",
                type: "pie",
                data: resourceSuffixData,
                center: ["66%", "60%"],
                radius: ["45%", "70%"],
              },
            ],
          };
          // 多媒体文件容量比例option
          // var resourceTypeoption = {
          //   title: {
          //     text: "多媒体文件容量比例",
          //     left: "center",
          //   },
          //   tooltip: {
          //     trigger: "item",
          //     formatter: "{a} <br/>{b} : {c} MB ({d}%)",
          //   },
          //   legend: {
          //     orient: "vertical",
          //     left: "5%",
          //     top: "10%",
          //     data: ["图片", "视频", "音频", "3D"],
          //   },
          //   series: [
          //     {
          //       name: "多媒体文件容量比例",
          //       type: "pie",
          //       data: response.obj.resourceType,
          //       center: ["66%", "60%"],
          //       radius: ["55%", "70%"],
          //     },
          //   ],
          // };
          // 专业学科分类统计option
          var countZyoption = {
            title: {
              text: "专业学科分类统计",
              left: "center",
            },
            grid: {
              top: "20%",
              left: "15%",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            xAxis: {
              data: countZyDataX,
              axisLabel: {
                formatter: "{value} ",
                rotate: -22,
                margin: 10,
                fontSize: 10,
              },
            },
            yAxis: {},
            series: [
              {
                name: "专业学科分类统计",
                type: "bar",
                data: countZyDataY,
              },
            ],
          };
          // 专题类型资源统计option
          // var countZtoption = {
          //   title: {
          //     text: "专题类型资源统计",
          //     left: "center",
          //   },
          //   grid: {
          //     top: "20%",
          //     left: "15%",
          //   },
          //   tooltip: {
          //     trigger: "item",
          //     formatter: "{a} <br/>{b} : {c} ",
          //   },
          //   xAxis: {
          //     data: countZtDataX,
          //     axisLabel: {
          //       formatter: "{value} ",
          //       rotate: -22,
          //       margin: 10,
          //       fontSize: 10,
          //     },
          //   },
          //   yAxis: {},
          //   series: [
          //     {
          //       name: "专题类型资源统计",
          //       type: "bar",
          //       data: countZtDataY,
          //     },
          //   ],
          // };
          //产品多媒体资源统计option
          var productResourceoption = {
            title: {
              text: "产品多媒体资源统计",
              left: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ",
            },
            legend: {
              orient: "horizontal",
              left: "left",
              top: "8%",
              data: ["图片", "音频", "视频"],
            },
            xAxis: {
              data: productResourceDataX,
              axisLabel: {
                formatter: "{value} ",
                rotate: -22,
                margin: 10,
                fontSize: 10,
              },
            },
            yAxis: {},
            series: [
              {
                name: "图片",
                data: productResourceDataImg,
                type: "bar",
                stack: "x",
              },
              // {
              //   data: productResourceData3D,
              //   type: 'bar',
              //   stack: 'x'
              // },
              {
                name: "音频",
                data: productResourceDataAudio,
                type: "bar",
                stack: "x",
              },
              {
                name: "视频",
                data: productResourceDataVideo,
                type: "bar",
                stack: "x",
              },
            ],
            grid: {
              top: "20%",
              left: "15%",
            },
          };
          //行业资源统计option
          // var industryCountoption = {
          //   title: {
          //     text: "行业资源分类统计",
          //     left: "center",
          //   },
          //   grid: {
          //     top: "20%",
          //     left: "15%",
          //   },
          //   tooltip: {
          //     trigger: "item",
          //     formatter: "{a} <br/>{b} : {c}",
          //   },
          //   xAxis: {
          //     data: industryShowData.map((item, index) => {
          //       if (index < 10) {
          //         return item.name;
          //       }
          //     }),
          //     axisLabel: {
          //       formatter: "{value} ",
          //       rotate: -22,
          //       margin: 10,
          //       fontSize: 10,
          //     },
          //   },
          //   yAxis: {},
          //   series: [
          //     {
          //       name: "行业资源分类统计",
          //       type: "bar",
          //       data: industryShowData.map((item, index) => {
          //         if (index < 10) {
          //           return item.value;
          //         }
          //       }),
          //     },
          //   ],
          // };
          // 所有chart
          resourceSuffixChart.setOption(resourceSuffixoption);
          // resourceTypeChart.setOption(resourceTypeoption);
          countZyChart.setOption(countZyoption);
          // countZtChart.setOption(countZtoption);
          productResourceChart.setOption(productResourceoption);
          // industryCountChart.setOption(industryCountoption);
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
  },
  methods: {
    // 3D云标签
    onload3dtags() {
      var radius = 120;
      var dtr = Math.PI / 180;
      var d = 300;
      var mcList = [];
      var active = true;
      var lasta = 1;
      var lastb = 1;
      var distr = true;
      var tspeed = 1;
      var size = 300;
      var mouseX = 100;
      var mouseY = 0;
      var howElliptical = 1;
      var aA = null;
      var ca,
        sa,
        cb,
        sb,
        cc,
        sc,
        per = 0;
      var oDiv = null;
      function onload3dtags() {
        var i = 0;
        var oTag = null;
        oDiv = document.getElementById("tagbox");
        aA = oDiv.getElementsByTagName("a");
        for (i = 0; i < aA.length; i++) {
          oTag = {};
          oTag.offsetWidth = aA[i].offsetWidth;
          oTag.offsetHeight = aA[i].offsetHeight;
          mcList.push(oTag);
        }
        sineCosine(0, 0, 0);
        positionAll();
        oDiv.onmouseover = function () {
          active = false;
        };
        oDiv.onmouseout = function () {
          active = true;
        };
        // oDiv.onmousemove = function (ev) {
        //     // var oEvent = window.event || ev;
        //     // mouseX = oEvent.clientX - (oDiv.offsetLeft + oDiv.offsetWidth / 2);
        //     // mouseY = oEvent.clientY - (oDiv.offsetTop + oDiv.offsetHeight / 2);
        //     // mouseX /= 5;
        //     // mouseY /= 5
        //     console.log(111)
        // }

        setInterval(update, 30);
      }
      function update() {
        var a;
        var b;
        if (active) {
          a = (-Math.min(Math.max(-mouseY, -size), size) / radius) * tspeed;
          b = (Math.min(Math.max(-mouseX, -size), size) / radius) * tspeed;
        } else {
          a = lasta * 0.98;
          b = lastb * 0.98;
        }
        lasta = a;
        lastb = b;
        if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
          return;
        }
        var c = 0;
        sineCosine(a, b, c);
        for (var j = 0; j < mcList.length; j++) {
          var rx1 = mcList[j].cx;
          var ry1 = mcList[j].cy * ca + mcList[j].cz * -sa;
          var rz1 = mcList[j].cy * sa + mcList[j].cz * ca;
          var rx2 = rx1 * cb + rz1 * sb;
          var ry2 = ry1;
          var rz2 = rx1 * -sb + rz1 * cb;
          var rx3 = rx2 * cc + ry2 * -sc;
          var ry3 = rx2 * sc + ry2 * cc;
          var rz3 = rz2;
          mcList[j].cx = rx3;
          mcList[j].cy = ry3;
          mcList[j].cz = rz3;
          per = d / (d + rz3);
          mcList[j].x = howElliptical * rx3 * per - howElliptical * 2;
          mcList[j].y = ry3 * per;
          mcList[j].scale = per;
          mcList[j].alpha = per;
          mcList[j].alpha = (mcList[j].alpha - 0.6) * (10 / 6);
        }
        if (IEVersion() !== 9 && IEVersion() !== 10 && IEVersion() !== 11) {
          doPosition();
        }
        depthSort();
      }
      function depthSort() {
        var i = 0;
        var aTmp = [];
        for (i = 0; i < aA.length; i++) {
          aTmp.push(aA[i]);
        }
        aTmp.sort(function (vItem1, vItem2) {
          if (vItem1.cz > vItem2.cz) {
            return -1;
          } else {
            if (vItem1.cz < vItem2.cz) {
              return 1;
            } else {
              return 0;
            }
          }
        });
        for (i = 0; i < aTmp.length; i++) {
          aTmp[i].style.zIndex = i;
        }
      }
      function positionAll() {
        var phi = 0;
        var theta = 0;
        var max = mcList.length;
        var i = 0;
        var aTmp = [];
        var oFragment = document.createDocumentFragment();
        for (i = 0; i < aA.length; i++) {
          aTmp.push(aA[i]);
        }
        aTmp.sort(function () {
          return Math.random() < 0.5 ? 1 : -1;
        });
        for (i = 0; i < aTmp.length; i++) {
          oFragment.appendChild(aTmp[i]);
        }
        oDiv.appendChild(oFragment);
        for (var j = 1; j < max + 1; j++) {
          if (distr) {
            phi = Math.acos(-1 + (2 * j - 1) / max);
            theta = Math.sqrt(max * Math.PI) * phi;
          } else {
            phi = Math.random() * Math.PI;
            theta = Math.random() * (2 * Math.PI);
          }
          mcList[j - 1].cx = radius * Math.cos(theta) * Math.sin(phi);
          mcList[j - 1].cy = radius * Math.sin(theta) * Math.sin(phi);
          mcList[j - 1].cz = radius * Math.cos(phi);
          aA[j - 1].style.left =
            mcList[j - 1].cx +
            oDiv.offsetWidth / 2 -
            mcList[j - 1].offsetWidth / 2 +
            "px";
          aA[j - 1].style.top =
            mcList[j - 1].cy +
            oDiv.offsetHeight / 2 -
            mcList[j - 1].offsetHeight / 2 +
            "px";
        }
      }
      function doPosition() {
        var l = oDiv.offsetWidth / 2;
        var t = oDiv.offsetHeight / 2;
        for (var i = 0; i < mcList.length; i++) {
          aA[i].style.left =
            mcList[i].cx + l - mcList[i].offsetWidth / 2 + "px";
          aA[i].style.top =
            mcList[i].cy + t - mcList[i].offsetHeight / 2 + "px";
          aA[i].style.fontSize =
            Math.ceil((12 * mcList[i].scale) / 2) + 8 + "px";
          aA[i].style.filter = "alpha(opacity=" + 100 * mcList[i].alpha + ")";
          aA[i].style.opacity = mcList[i].alpha;
        }
      }
      function sineCosine(a, b, c) {
        sa = Math.sin(a * dtr);
        ca = Math.cos(a * dtr);
        sb = Math.sin(b * dtr);
        cb = Math.cos(b * dtr);
        sc = Math.sin(c * dtr);
        cc = Math.cos(c * dtr);
      }
      function IEVersion() {
        var userAgent = navigator.userAgent;
        var isIE =
          userAgent.indexOf("compatible") > -1 &&
          userAgent.indexOf("MSIE") > -1;
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE;
        var isIE11 =
          userAgent.indexOf("Trident") > -1 &&
          userAgent.indexOf("rv:11.0") > -1;
        if (isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if (fIEVersion == 7) {
            return 7;
          } else {
            if (fIEVersion == 8) {
              return 8;
            } else {
              if (fIEVersion == 9) {
                return 9;
              } else {
                if (fIEVersion == 10) {
                  return 10;
                } else {
                  return 6;
                }
              }
            }
          }
        } else {
          if (isEdge) {
            return "edge";
          } else {
            if (isIE11) {
              return 11;
            } else {
              return -1;
            }
          }
        }
      }
      onload3dtags();
    },
    handleClick(tab) {
      let that = this;
      that.productTableData = [];
      var currentNum = tab.index * 10;
      var endNum = "";
      if (this.productTableDataAll.length - currentNum < 10) {
        endNum = this.productTableDataAll.length;
      } else {
        endNum = currentNum + 10;
      }
      for (let index = currentNum; index < endNum; index++) {
        that.productTableData.push(this.productTableDataAll[index]);
      }
    },
    ZyMoreView(page) {
      let that = this;
      this.countZyDialog = true;
      that.currentPageZy = 1;
      that.countZyTableData = [];
      if (page == 1) {
        for (var i = 0; i < 10; i++) {
          that.countZyTableData.push(this.countZyTableDataAll[i]);
        }
      } else {
        for (var j = (page - 1) * 10; j < page * 10; j++) {
          that.countZyTableData.push(this.countZyTableDataAll[j]);
        }
      }
      that.totalSizeZy = this.countZyTableDataAll.length;
    },
    // 分页
    handleCurrentChangeZy(val) {
      this.ZyMoreView(val);
      this.currentPageZy = val;
    },
    ZtMoreView(page) {
      let that = this;
      this.countZtDialog = true;
      that.currentPageZt = 1;
      that.countZtTableData = [];
      if (page == 1) {
        for (var i = 0; i < 10; i++) {
          that.countZtTableData.push(this.countZtTableDataAll[i]);
        }
      } else {
        for (var j = (page - 1) * 10; j < page * 10; j++) {
          that.countZtTableData.push(this.countZtTableDataAll[j]);
        }
      }
      that.totalSizeZt = this.countZtTableDataAll.length;
    },
    // 分页
    handleCurrentChangeZt(val) {
      this.ZtMoreView(val);
      this.currentPageZt = val;
    },
    PRMoreView(page) {
      let that = this;
      this.productResourceDialog = true;
      that.currentPagePR = 1;
      that.productResourceTableData = [];
      if (page == 1) {
        for (var i = 0; i < 10; i++) {
          that.productResourceTableData.push(
            this.productResourceTableDataAll[i]
          );
        }
      } else {
        for (var j = (page - 1) * 10; j < page * 10; j++) {
          that.productResourceTableData.push(
            this.productResourceTableDataAll[j]
          );
        }
      }
      that.totalSizePR = this.productResourceTableDataAll.length;
    },

    // 分页
    handleCurrentChangePR(val) {
      this.PRMoreView(val);
      this.currentPagePR = val;
    },
    productMoreView(page) {
      let that = this;
      that.productTableData = [];
      that.currentPageProduct = 1;
      if (page == 1) {
        for (var i = 0; i < 10; i++) {
          that.productTableData.push(this.productTableDataAll[i]);
        }
      } else {
        for (var j = (page - 1) * 10; j < page * 10; j++) {
          that.productTableData.push(this.productTableDataAll[j]);
        }
      }
      that.totalSizeProduct = this.productTableDataAll.length;
      // for (let index = 0; index < 10; index++) {
      //   that.productTableData.push(this.productTableDataAll[index]);
      // }
      this.productDialog = true;
    },
    // 分页
    handleCurrentChangeProduct(val) {
      this.productMoreView(val);
      this.currentPageProduct = val;
    },
    getRandomIntInclusive(min, max) {
      const minCeiled = Math.ceil(min);
      const maxFloored = Math.floor(max);
      return Math.floor(
        Math.random() * (maxFloored - minCeiled + 1) + minCeiled
      ); // 包含最小值和最大值
    },
  },
};
</script>

<style>
body {
  overflow-x: hidden;
}
#countMainBox {
  padding: 50px 100px;
  width: calc(100% - 170px);
}

#mideleContentBox {
  overflow: auto;
}
#mideleContentBox::after {
  content: "";
  display: inline-block;
  clear: both;
}

#countPageTitle {
  color: #000;
  font-size: 30px;
  font-weight: bolder;
  text-align: center;
  margin-bottom: 50px;
}

#countMainBox .contentBox {
  float: left;
  width: 32%;
}

.countLeftBottom #resourceSuffix,
#countRightBox #resourceType {
  padding: 10px 0;
  height: 320px;
  width: 97.5%;
  margin-bottom: 5px;
  border: 1px solid rgba(136, 136, 136, 0.5);
  margin-left: 1%;
  z-index: 50;
}

#countMiddleBox {
  border: 1px solid rgba(136, 136, 136, 0.5);
  padding: 10px 0;
}

#countSum {
  text-align: center;
}

#countSum .numberShow {
  background-color: #50b58d;
  margin: 0 5px;
  color: #fff;
  font-size: 38px;
  font-weight: bolder;
  line-height: 3em;
  /* padding: 10px 12px; */
  padding: 10px 10px;
}

#countSum .dot {
  margin: 0 5px;
  color: #50b58d;
  font-size: 38px;
  font-weight: bolder;
  /* padding: 10px 12px; */
  padding: 10px 7px;
}

#productBox,
#countTypeBox {
  position: relative;
}

#productBox .moreView,
#countTypeBox .moreView {
  position: absolute;
  font-size: 14px;
  right: 2%;
  top: 1%;
}

#countTypeBox .title,
#productBox .title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 31.5px;
}

#productBox .el-tabs__item {
  width: 30px;
  padding: 0;
}

#productBox .el-tabs__active-bar {
  width: 30px !important;
  height: 3px;
}

#productBox .el-tabs__nav-wrap::after {
  width: 90px;
  height: 3px;
  right: 0;
  left: auto;
}

#productBox .el-tabs__item {
  height: 5px;
  line-height: 5px;
}

#productBox .el-tabs__nav {
  float: right;
}

#countZy,
#countZt {
  width: 97.5%;
  height: 400px;
  margin-left: 5px;
  margin-bottom: 10px;
  padding-top: 20px;
  border: 1px solid rgba(136, 136, 136, 0.5);
}

#productResource,
#industryCount {
  width: 97.5%;
  height: 400px;
  margin-left: 5px;
  margin-bottom: 5px;
  padding-top: 20px;
  border: 1px solid rgba(136, 136, 136, 0.5);
}

.countZyBox,
.countZtBox,
.productResourceBox {
  position: relative;
}

#countMainBox #countLeftBox .moreView,
#countMainBox #countRightBox .moreView {
  position: absolute;
  font-size: 14px;
  top: 5%;
  right: 5%;
}
#countMainBox #countLeftBox .moreView:hover,
#countMainBox #countRightBox .moreView:hover,
#productBox .moreView:hover,
#countTypeBox .moreView:hover {
  color: #50b58d;
}

#countMainBox #bottomBox {
  border: 1px solid rgba(136, 136, 136, 0.5);
  width: 95.2%;
  /* height: 300px; */
  height: 100vh;
  margin-bottom: 20px;
  margin-left: 5px;
}

#knowledgeGraph {
  width: 100%;
  /* height: 300px; */
  height: 100vh;
}

#countMiddleBox #sumData {
  /* margin-left: 7px; */
  font-size: 14px;
}

#countMiddleBox #sumData div {
  margin: 0 4px;
  float: left;
}
.words_chart {
  border-top: 0;
  border: 1px solid rgba(136, 136, 136, 0.5);
  margin-left: 5px;
  margin-bottom: 5px;
  padding: 20px 0;
  width: 97.5%;
  height: 347px;
  -moz-box-sizing: border-box; /*Firefox3.5+*/
  -webkit-box-sizing: border-box; /*Safari3.2+*/
  -o-box-sizing: border-box; /*Opera9.6*/
  -ms-box-sizing: border-box; /*IE8*/
  box-sizing: border-box;
}
.words_chart .hotTitle {
  text-align: center;
  font-size: 20px;
  font-weight: bolder;
}
#tagbox {
  position: relative;
  z-index: 0;
  overflow: hidden;
  height: 100%;
}
#tagbox a {
  position: absolute;
  padding: 3px 6px;
  font-family: Microsoft YaHei;
  color: #fff;
  top: 0;
  font-weight: bold;
  text-decoration: none;
  left: 0;
}
#tagbox a:hover {
  border: #eee 1px solid;
  background: #f2f5f9;
}
#tagbox .c1 {
  color: #427dc9;
}
#tagbox .c2 {
  color: #a69fd5;
}
#tagbox .c3 {
  color: #4152b9;
}
#tagbox .c4 {
  color: #34418d;
}
#tagbox .c5 {
  color: #e59c6f;
}
#tagbox .c6 {
  color: #629667;
}
#tagbox .c7 {
  color: #85b7be;
}
#tagbox .c8 {
  color: #8dc9b0;
}
#tagbox .c9 {
  color: #f29a9e;
}
</style>